/**
 * @file track-kinds.js
 */

/**
 * https://html.spec.whatwg.org/multipage/embedded-content.html#dom-videotrack-kind
 *
 * enum VideoTrackKind {
 *   "alternative",
 *   "captions",
 *   "main",
 *   "sign",
 *   "subtitles",
 *   "commentary",
 *   "",
 * };
 */
'use strict';

exports.__esModule = true;
var VideoTrackKind = {
  alternative: 'alternative',
  captions: 'captions',
  main: 'main',
  sign: 'sign',
  subtitles: 'subtitles',
  commentary: 'commentary'
};

/**
 * https://html.spec.whatwg.org/multipage/embedded-content.html#dom-audiotrack-kind
 *
 * enum AudioTrackKind {
 *   "alternative",
 *   "descriptions",
 *   "main",
 *   "main-desc",
 *   "translation",
 *   "commentary",
 *   "",
 * };
 */
var AudioTrackKind = {
  alternative: 'alternative',
  descriptions: 'descriptions',
  main: 'main',
  'main-desc': 'main-desc',
  translation: 'translation',
  commentary: 'commentary'
};

/**
 * https://html.spec.whatwg.org/multipage/embedded-content.html#texttrackkind
 *
 * enum TextTrackKind {
 *   "subtitles",
 *   "captions",
 *   "descriptions",
 *   "chapters",
 *   "metadata"
 * };
 */
var TextTrackKind = {
  subtitles: 'subtitles',
  captions: 'captions',
  descriptions: 'descriptions',
  chapters: 'chapters',
  metadata: 'metadata'
};

/**
 * https://html.spec.whatwg.org/multipage/embedded-content.html#texttrackmode
 *
 * enum TextTrackMode { "disabled",  "hidden",  "showing" };
 */
var TextTrackMode = {
  disabled: 'disabled',
  hidden: 'hidden',
  showing: 'showing'
};

/* jshint ignore:start */
// we ignore jshint here because it does not see
// AudioTrackKind as defined here
exports['default'] = { VideoTrackKind: VideoTrackKind, AudioTrackKind: AudioTrackKind, TextTrackKind: TextTrackKind, TextTrackMode: TextTrackMode };

/* jshint ignore:end */
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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